
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import moment from 'moment';
import Swal from 'sweetalert2';
import { IdbService } from '../idb/idb.service';
import { map } from 'lodash';
import * as _ from 'lodash';
import { environment } from '../../../environments/environment';
// import { environment } from 'src/environments/environment';


interface Action { id: string, action: string, menu: string, ongle: string, checked?: boolean }
interface Menu { name: string, url: string, iconComponent: { name: string }, les_actions: Action[], children?: any[] }

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  local_storage_prefixe = "kodi-hgs.com";
  taf_base_url = environment.taf_base_url

  les_factures: any[] = []
  les_mairies: any[] = []
  les_transactions: any[] = []
  les_paiements: any[] = []
  les_taxes: any[] = []
  les_campagnes: any[] = []
  les_zones: any[] = []
  les_agents: any[] = []
  les_tarif_stationnements: any[] = []
  les_abonnement_stationnements: any[] = []
  les_stationnements: any[] = []
  les_tarif_publicitaires: any[] = []
  les_parkings: any[] = []
  les_commandes: any[] = []
  les_sabotages: any[] = []
  les_type_paiements: any[] = []
  les_droits: any[] = []
  les_documentations: any[] = []
  les_deliberations: any[] = []
  les_categories: any[] = []
  les_collecteurs: any[] = []
  
full_menu = [
    {
      name: 'Tableau de bord — Global',
      url: '/home/dashboard',
      iconComponent: { name: 'cil-speedometer' },
      les_actions: [
        { menu: "Tableau de bord — Global", ongle: "Tableau de bord — Global", id: "/home/dashboard", action: "Acceder au tableau de bord global (admin)" },       
      ]
    },
    {
      name: 'Tableau de bord — Ma mairie',
      url: '/home/ma_mairie',
      iconComponent: { name: 'cil-speedometer' },
      les_actions: [
        { menu: "Tableau de bord — Ma mairie", ongle: "Tableau de bord — Ma mairie", id: "/home/ma_mairie", action: "Acceder au tableau de bord de sa propre mairie (Maire)" },
      ]
    },
    {
      name: 'Tableau de bord — Perception',
      url: '/home/dashboard/perception',
      iconComponent: { name: 'cil-speedometer' },
      les_actions: [
        { menu: "Tableau de bord — Perception", ongle: "Tableau de bord — Perception", id: "/home/dashboard/perception", action: "Acceder au tableau de bord de la perception" },
      ]
    },

    {
      name: 'Perceptions',
      url: '/home/perception',
      iconComponent: { name: 'cil-briefcase' },
      les_actions: [
        { menu: "Perception", ongle: "Perception", id: "/home/perception", action: "Acceder a la liste des perceptions" },
        { menu: "Perception", ongle: "Perception", id: "perception.add", action: "Ajouter une nouvelle perception" },
        { menu: "Perception", ongle: "Perception", id: "perception.edit", action: "Modifier une perception" },
        { menu: "Perception", ongle: "Perception", id: "perception.detail", action: "Afficher les details d'une perception" },
      ]
    },
    {
      name: 'Mairies',
      url: '/home/mairie',
      iconComponent: { name: 'cil-home' },
      les_actions: [
        { menu: "Mairie", ongle: "Mairie", id: "/home/mairie", action: "Acceder a la liste des mairies" },
        { menu: "Mairie", ongle: "Mairie", id: "mairie.add", action: "Ajouter une nouvelle Mairie" },
        { menu: "Mairie", ongle: "Mairie", id: "mairie.edit", action: "Modifier une Mairie" },
      ]
    },
    {
      name: 'Zones',
      url: '/home/zone',
      iconComponent: { name: 'cil-3d' },
      les_actions: [
        { menu: "Zone", ongle: "Zone", id: "/home/zone", action: "Acceder a la liste des zones" },
        { menu: "Zone", ongle: "Zone", id: "zone.add", action: "Ajouter une nouvelle zone" },
        { menu: "Zone", ongle: "Zone", id: "zone.edit", action: "Modifier une zone" },
        { menu: "Zone", ongle: "Zone", id: "zone.detail", action: "Afficher les details d'une zone" },
        { menu: "Secteur", ongle: "Secteur", id: "secteur.add", action: "Ajouter un nouveau secteur" },
        { menu: "Secteur", ongle: "Secteur", id: "secteur.edit", action: "Modifier un secteur" },
        { menu: "Secteur", ongle: "Secteur", id: "secteur.list", action: "Acceder a la liste des secteurs" },
      ]
    },
    {
      name: 'Taxes',
      url: '/home/taxe',
      iconComponent: { name: 'cil-arrow-thick-bottom' },
      les_actions: [
        { menu: "Taxe", ongle: "Taxe", id: "/home/taxe", action: "Acceder a la liste des taxes" },
        { menu: "Taxe", ongle: "Taxe", id: "taxe.add", action: "Ajouter une nouvelle taxe" },
        { menu: "Taxe", ongle: "Taxe", id: "taxe.edit", action: "Modifier une taxe" },
        { menu: "Taxe", ongle: "Taxe", id: "taxe.detail", action: "Afficher les details d'une taxe" },
        { menu: "Taxe", ongle: "Taxe", id: "tarif.add", action: "Ajouter un tarif pour une taxe" },
        { menu: "Taxe", ongle: "Taxe", id: "tarif.edit", action: "Modifier un tarif pour une taxe" },
      ]
    },
    {
      name: 'Deliberations',
      url: '/home/deliberation',
      iconComponent: { name: 'cil-file' },
      les_actions: [
        { menu: "Deliberation", ongle: "Deliberation", id: "/home/deliberation", action: "Acceder a la liste des deliberations" },
        { menu: "Deliberation", ongle: "Deliberation", id: "deliberation.add", action: "Ajouter une nouvelle deliberation" },
        { menu: "Deliberation", ongle: "Deliberation", id: "deliberation.edit", action: "Modifier une deliberation" },
      ]
    },
     {
      name: 'Activites',
      url: '/home/activite',
      iconComponent: { name: 'cil-equalizer' },
      les_actions: [
        { menu: "Activite", ongle: "Activite", id: "/home/activite", action: "Acceder a la liste des activites" },
        { menu: "Activite", ongle: "Activite", id: "activite.add", action: "Ajouter une nouvelle activite" },
        { menu: "Activite", ongle: "Activite", id: "activite.edit", action: "Modifier une activite" },
        // { menu: "Activite", ongle: "Activite", id: "activite.delete", action: "Supprimer une activite" },
      ]
    },
    {
      name: 'Contribuables',
      url: '/home/contribuable',
      iconComponent: { name: 'cil-people' },
      les_actions: [
        { menu: "Contribuable", ongle: "Contribuable", id: "/home/contribuable", action: "Acceder a la liste des contribuables" },
        { menu: "Contribuable", ongle: "Contribuable", id: "contribuable.add", action: "Ajouter un nouveau contribuable" },
        { menu: "Contribuable", ongle: "Contribuable", id: "contribuable.edit", action: "Modifier un contribuable" },
        { menu: "Contribuable", ongle: "Contribuable", id: "contribuable.details", action: "Voir les details d'un contribuable" },
        { menu: "Contribuable", ongle: "Contribuable", id: "contribuable.export", action: "Exporter la liste des contribuables" },
      ]
    },
    {
      name: 'Campagnes de Recensement',
      url: '/home/campagne',
      iconComponent: { name: 'cil-bullhorn' },
      les_actions: [
        { menu: "Campagne", ongle: "Campagne", id: "/home/campagne", action: "Acceder a la liste des campagnes" },
        { menu: "Campagne", ongle: "Campagne", id: "campagne.add", action: "Ajouter une nouvelle campagne" },
        { menu: "Campagne", ongle: "Campagne", id: "campagne.edit", action: "Modifier une campagne" },
      ]
    },
   
    
    
    {
      name: 'Validation du recensement',
      url: '/home/apurement',
      iconComponent: { name: 'cil-check' },
      les_actions: [
        { menu: "Validation du recensement", ongle: "Validation du recensement", id: "/home/apurement", action: "Acceder aux validations" },
        { menu: "Validation du recensement", ongle: "Validation du recensement", id: "validation.add", action: "Ajouter une nouvelle validation" },
        // { menu: "Validation du recensement", ongle: "Validation du recensement", id: "validation.edit", action: "Modifier une validation" },
        { menu: "Validation du recensement", ongle: "Validation du recensement", id: "validation.annuler_or", action: "Annuler un ordre de recette (rejet définitif)" },
      ]
    },
    {
      // Cas où un agent de recensement a répondu "non, pas le même
      // contribuable" à une alerte de doublon NINEA/CNI (identite_fiscale) —
      // à vérifier par la mairie, cf. identite_fiscale/alertes_a_verifier.php.
      name: 'Identités à vérifier',
      url: '/home/identite-fiscale/alertes',
      iconComponent: { name: 'cil-fingerprint' },
      les_actions: [
        { menu: "Identités à vérifier", ongle: "Identités à vérifier", id: "/home/identite-fiscale/alertes", action: "Acceder aux identites fiscales a verifier" },
        { menu: "Identités à vérifier", ongle: "Identités à vérifier", id: "identite_fiscale.marquer_verifie", action: "Marquer une alerte d'identite comme verifiee" },
      ]
    },
    {
      // ✅ Nettoyage (audit Trésor 02/09/2026) : ordre_recette.add/edit
      // supprimés — jamais vérifiés nulle part dans le code, le vrai verrou
      // de génération d'un OR passe par les droits "Apurement"/"Validation
      // du recensement" (l'OR est généré automatiquement à la validation du
      // recensement, pas via un formulaire "ajouter/modifier OR" manuel).
      name: 'Ordre de recette',
      url: '/home/ordre-recette',
      iconComponent: { name: 'cil-money' },
      les_actions: [
        { menu: "Ordre de recette", ongle: "Ordre de recette", id: "/home/ordre-recette", action: "Acceder aux ordres de recette" },
      ]
    },
    {
      name: 'Apurement',
      url: '/home/apurement/perception',
      iconComponent: { name: 'cil-x-circle' },
      les_actions: [
        { menu: "Apurement", ongle: "Apurement", id: "/home/apurement/perception", action: "Accéder à l'apurement des ordres de recette" },
      ]
    },
    {
      // Groupe "Recouvrement" (Trésor, sur demande) : rassemble tout ce qui
      // touche au recouvrement (amiable + contentieux) plutôt que de laisser
      // ces onglets dispersés dans une liste plate côté Receveur. Pas de
      // `url`/`les_actions` propres ici — un groupe est purement visuel,
      // sa visibilité découle de celle de ses enfants (cf. custom_menu()).
      // ✅ Renommé "Encaissements" → "Suivi du recouvrement" (audit Trésor
      // 02/09/2026) : Maire/Receveur/Adjoint doivent pouvoir consulter le
      // suivi sans pouvoir encaisser — encaissement.voir gate désormais le
      // bouton "Encaisser" lui-même (jamais vérifié avant), distinct de
      // encaissement.add qui gate la validation finale du versement dans le
      // formulaire de détail.
      name: 'Recouvrement',
      iconComponent: { name: 'cil-folder' },
      children: [
        {
          name: 'Suivi du recouvrement',
          url: '/home/encaissement',
          iconComponent: { name: 'cilMoney' },
          les_actions: [
            { menu: "Suivi du recouvrement", ongle: "Suivi du recouvrement", id: "/home/encaissement", action: "Acceder au suivi du recouvrement" },
            { menu: "Suivi du recouvrement", ongle: "Suivi du recouvrement", id: "encaissement.voir", action: "Voir le detail d'un encaissement" },
            { menu: "Suivi du recouvrement", ongle: "Suivi du recouvrement", id: "encaissement.add", action: "Encaisser (enregistrer un versement)" },
            { menu: "Suivi du recouvrement", ongle: "Suivi du recouvrement", id: "encaissement.solde", action: "Voir les titres soldes" },
            { menu: "Suivi du recouvrement", ongle: "Suivi du recouvrement", id: "encaissement.export", action: "Exporter" },
          ]
        },
        {
          name: 'Recouvrement contentieux',
          url: '/home/contentieux',
          iconComponent: { name: 'cil-warning' },
          les_actions: [
            { menu: "Recouvrement contentieux", ongle: "Recouvrement contentieux", id: "/home/contentieux", action: "Acceder au recouvrement contentieux" },
            { menu: "Recouvrement contentieux", ongle: "Recouvrement contentieux", id: "contentieux.generer", action: "Generer un acte de poursuite" },
            { menu: "Recouvrement contentieux", ongle: "Recouvrement contentieux", id: "contentieux.notifier", action: "Notifier un acte de poursuite par SMS" },
          ]
        },
        {
          name: 'Droit au comptant',
          url: '/home/droit-comptant',
          iconComponent: { name: 'cilMoney' },
          les_actions: [
            { menu: "Droit au comptant", ongle: "Droit au comptant", id: "/home/droit-comptant", action: "Acceder au suivi des droits au comptant (collecteurs ambulants)" },
          ]
        },
        {
          name: 'Moratoire',
          url: '/home/moratoire',
          iconComponent: { name: 'cil-calendar' },
          les_actions: [
            { menu: "Moratoire", ongle: "Moratoire", id: "/home/moratoire", action: "Acceder au module Moratoire" },
            { menu: "Moratoire", ongle: "Moratoire", id: "moratoire.enregistrer", action: "Enregistrer une demande de moratoire" },
            { menu: "Moratoire", ongle: "Moratoire", id: "moratoire.instruire", action: "Instruire un dossier de moratoire (eligibilite, echeancier, avis)" },
            { menu: "Moratoire", ongle: "Moratoire", id: "moratoire.decider", action: "Decider et formaliser un moratoire" },
          ]
        },
        {
          name: 'Situation Fiscale',
          url: '/home/situation-fiscale',
          iconComponent: { name: 'cil-notes' },
          les_actions: [
            { menu: "Situation Fiscale", ongle: "Situation Fiscale", id: "/home/situation-fiscale", action: "Acceder a la situation fiscale des contribuables" },
            { menu: "Situation Fiscale", ongle: "Situation Fiscale", id: "situation_fiscale.export_pdf", action: "Exporter la situation fiscale en PDF" },
            { menu: "Situation Fiscale", ongle: "Situation Fiscale", id: "situation_fiscale.generer_quitus", action: "Generer un quitus fiscal" },
          ]
        },
        {
          name: 'Campagnes de collecte',
          url: '/home/campagne_collecte',
          iconComponent: { name: 'cil-bullhorn' },
          les_actions: [
            { menu: "Campagnes de collecte", ongle: "Campagnes de collecte", id: "/home/campagne_collecte", action: "Acceder a la liste des campagnes de collecte" },
            { menu: "Campagnes de collecte", ongle: "Campagnes de collecte", id: "campagne_collecte.add", action: "Ajouter une nouvelle campagne de collecte" },
            { menu: "Campagnes de collecte", ongle: "Campagnes de collecte", id: "campagne_collecte.edit", action: "Modifier une campagne de collecte" },
          ]
        },
        {
          name: 'Agents de recouvrement',
          url: '/home/agent-collecteur',
          iconComponent: { name: 'cil-people' },
          // ✅ Nettoyage (audit Trésor 02/09/2026) : les 3 anciennes actions
          // ("Voir mes demandes", "Ajouter une demande", "Gerer les demandes")
          // décrivaient l'ancien circuit de demande/approbation de collecteur,
          // remplacé par la création directe (cf. commentaire home-routing.module.ts
          // sur la route "agent-collecteur") — /home/agent-collecteur/percepteur
          // et agent_collecteur.add ne sont plus atteignables du tout depuis
          // l'UI. Seul l'id "/home/agent-collecteur" reste réellement utilisé
          // (gate la visibilité de la liste des collecteurs), relabellisé en
          // conséquence.
          les_actions: [
            { menu: "Agent de recouvrement", ongle: "Agent de recouvrement", id: "/home/agent-collecteur", action: "Gerer les agents de recouvrement de la mairie" },
          ]
        },
      ]
    },
    {
      name: 'Utilisateurs',
      url: '/home/agent',
      iconComponent: { name: 'cil-user' },
      les_actions: [
        { menu: "Agent", ongle: "Agent", id: "/home/agent", action: "Acceder a la liste des agents" },
        { menu: "Agent", ongle: "Agent", id: "agent.add", action: "Ajouter un nouvel agent" },
        { menu: "Agent", ongle: "Agent", id: "agent.edit", action: "Modifier un agent" },
        { menu: "Agent", ongle: "Agent", id: "agent.details", action: "Voir les details d'un agent" },
        { menu: "Agent", ongle: "Agent", id: "agent.export", action: "Exporter la liste des agents" },
      ]
    },
    
    {
      name: 'Reclamations',
      url: '/home/reclamation',
      iconComponent: { name: 'cil-notes' },
      les_actions: [
        { menu: "Reclamation", ongle: "Reclamation", id: "/home/reclamation", action: "Acceder a la liste des reclamations" },
        { menu: "Reclamation", ongle: "Reclamation", id: "reclamation.detail", action: "Voir le detail d'une reclamation" },
        { menu: "Reclamation", ongle: "Reclamation", id: "reclamation.prendre_en_charge", action: "Prendre en charge une reclamation" },
        { menu: "Reclamation", ongle: "Reclamation", id: "reclamation.cloturer", action: "Cloturer une reclamation" },
      ]
    },
    {
      name: 'Guide d\'utilisation',
      url: '/home/documentation',
      iconComponent: { name: 'cil-menu' },
      les_actions: [
        { menu: "Guide d'utilisation", ongle: "Guide d'utilisation", id: "/home/documentation", action: "Acceder au guide d'utilisation" },
        { menu: "Guide d'utilisation", ongle: "Guide d'utilisation", id: "documentation.add", action: "Ajouter une nouvelle rubrique au guide" },
        { menu: "Guide d'utilisation", ongle: "Guide d'utilisation", id: "documentation.edit", action: "Modifier une rubrique du guide" },
        { menu: "Guide d'utilisation", ongle: "Guide d'utilisation", id: "documentation.detail", action: "Afficher les details d'une rubrique" },
      ]
    },
    {
      // Les ids des sous-onglets ci-dessous (autres que le premier) sont les
      // mêmes que ceux définis dans parametre.component.ts::sous_module — ce
      // sont deux tableaux séparés qui doivent rester synchronisés à la main
      // (sous_module pilote l'affichage de la sous-navigation, cette entrée
      // pilote leur sélection dans l'éditeur de privilèges). Avant cet ajout,
      // seul le droit d'accès global "/home/parametre" était sélectionnable
      // ici — impossible de cocher un sous-onglet précis pour un rôle.
      name: 'Parametres',
      url: '/home/parametre',
      iconComponent: { name: 'cil-settings' },
      les_actions: [
        { menu: "Parametre", ongle: "Parametre", id: "/home/parametre", action: "Acceder a la liste des parametres" },
        { menu: "Parametre", ongle: "Privilege", id: "/home/parametre/privilege", action: "Acceder a la liste des privileges" },
        { menu: "Parametre", ongle: "Activite", id: "/home/parametre/activite", action: "Acceder a la liste des activites" },
        // ⚠️ Les 4 ids ci-dessous sont les MÊMES que ceux de la section
        // "Activité" plus haut (activite.add/edit/delete/export) — dupliqués
        // ici volontairement pour que le bouton "Ajouter" (qui vérifie ces
        // ids exacts côté composant, cf. list-activite.component.html) soit
        // cochable directement depuis la section Parametres, sans devoir
        // ouvrir une autre section pour la même page.
        { menu: "Parametre", ongle: "Activite", id: "activite.add", action: "Ajouter une nouvelle activite (parametre)" },
        { menu: "Parametre", ongle: "Activite", id: "activite.edit", action: "Modifier une activite (parametre)" },
        { menu: "Parametre", ongle: "Activite", id: "activite.export", action: "Exporter les activites (parametre)" },
        { menu: "Parametre", ongle: "Perception", id: "/home/parametre/perception", action: "Acceder a la liste des perceptions (parametre)" },
        { menu: "Parametre", ongle: "Taxe", id: "/home/parametre/taxe", action: "Acceder a la liste des taxes (parametre)" },
        // Idem que pour Activité ci-dessus : mêmes ids que ceux vérifiés par
        // list-taxe-nomenclature.component.html.
        { menu: "Parametre", ongle: "Taxe", id: "taxe.add", action: "Ajouter une nouvelle taxe (parametre)" },
        { menu: "Parametre", ongle: "Taxe", id: "taxe.edit", action: "Modifier une taxe (parametre)" },
        { menu: "Parametre", ongle: "Taxe", id: "taxe.export", action: "Exporter les taxes (parametre)" },
        { menu: "Parametre", ongle: "Chapitre", id: "/home/parametre/chapitre", action: "Acceder a la liste des chapitres" },
        { menu: "Parametre", ongle: "Guide d'utilisation", id: "/home/parametre/documentation", action: "Acceder au guide d'utilisation (parametre)" },
        { menu: "Parametre", ongle: "Guide d'utilisation", id: "documentation.add", action: "Ajouter une rubrique au guide (parametre)" },
        { menu: "Parametre", ongle: "Moyen Encaissement", id: "/home/parametre/type-paiement", action: "Acceder a la liste des types de paiement" },
        { menu: "Parametre", ongle: "Type de Reclamation", id: "/home/parametre/type-reclamation", action: "Acceder a la liste des types de reclamation" },
        // { menu: "Parametre", ongle: "Securite", id: "/home/parametre/securite", action: "Acceder a la liste des securites" },
        { menu: "Parametre", ongle: "SMS", id: "/home/parametre/sms", action: "Acceder a la liste des SMS" },
        { menu: "Parametre", ongle: "Langue", id: "/home/parametre/langue", action: "Acceder a la liste des langues" },
      ]
    },
    {
      name: 'Application Mobile',
      url: '/home/mobile',
      iconComponent: { name: 'cil-mobile' },
      les_actions: [
        { menu: "Application Mobile", ongle: "Application Mobile", id: "mobile.recensement", action: "Acceder au module mobile Recensement" },
        { menu: "Application Mobile", ongle: "Application Mobile", id: "mobile.collecte", action: "Acceder au module mobile Collecte" },
        { menu: "Application Mobile", ongle: "Application Mobile", id: "mobile.payer_taxes", action: "Acceder au module mobile Payer mes taxes" },
      ]
    },
  ];


  data: any = {
    les_parkings: [],
    les_stationnements: [],
    les_sabotages: [],
  }
  data_pub: any = {
    les_paiement_publicites: []
  }
  hide_on_print = false
  les_paiement_publicites: any[] = []
  mode: any = {
    status: true// true = online et false = offline
  }
  mairie_data: any = {
    les_contribuables: [],
  }
  les_activites: any[] = []
  version: any = {
    id: "2.0.0",
  }
  show_sidebar = true

  preference: any = {
    "assistance.route": "documentation"
  }
  menu: any[] = [];
  loading_les_droits = false;
  infos: any = {
    agent: {},
    les_mairies: [],
    les_perceptions: [],
    current_mairie: {},
    network: {
      token: undefined,
      status: true,
      message: "Aucun probléme détecté",
    },
    token_key: null,
    token: {
      token_key: null,
      token_decoded: null,
      user_connected: null,
      is_expired: null,
      date_expiration: null
    },
    les_droits_agent: []
  }
  constructor(private http: HttpClient, private route: Router, private idb: IdbService) { }

  async get_from_local_storage(key: string): Promise<any> {
    try {
      let res: any = await this.idb.get_from_indexedDB(key)
      return res
    } catch (error) {
      console.error("erreur de recuperation", error)
      return null
    }
  }
  async save_on_local_storage(key: string, value: any): Promise<void> {
    await this.idb.save_on_indexedDB(key, value);
  }
  async delete_from_local_storage(key: string) {
    await this.idb.delete_from_indexedDB(key);
  }
  async is_connected() {
    let token = await this.get_from_local_storage("token")
    if (token == null) {
      return false
    } else {
      return true
    }
  }

  on_token_expire() {
    this.Swal_error("Votre session s'est expiré! Veuillez vous connecter à nouveau")
    this.delete_from_local_storage("token")
    this.route.navigate(['/public/login'])
  }
  // 🐞 DEBUG TEMPORAIRE — à retirer une fois le débogage Oracle terminé.
  // Ajoute le contournement d'assainissement des erreurs (TafConfig::assainir_sortie
  // still masque tout le reste) et affiche le message technique réel dans une
  // popup dès qu'une réponse échoue, plutôt que d'aller chercher les logs serveur
  // à chaque fois.
  private debug_url(api_url: string): string {
    return api_url + (api_url.includes('?') ? '&' : '?') + 'debug_errors=koomcom';
  }
  private debug_afficher_erreur_reelle(reponse: any) {
    if (reponse && reponse.status === false) {
      const msg = reponse.erreur || reponse.message
        || (Array.isArray(reponse.errors) && reponse.errors[0]?.message)
        || null;
      if (msg) {
        // Affichée APRÈS le on_success(reponse) du composant appelant (souvent
        // un Swal_error générique) — sinon SweetAlert2 remplace immédiatement
        // cette popup par celle du composant (un seul Swal visible à la fois).
        setTimeout(() => this.Swal_error("[DEBUG] " + msg, 30000), 100);
      }
    }
  }

  async taf_get(path: string, on_success: (...args: any[]) => void, on_error: (...args: any[]) => void) {
    let api_url = this.debug_url(this.taf_base_url + path);
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.infos.token.token_key,
      })
    };

    this.http.get(api_url, httpOptions).subscribe(
      (reponse: any) => {// on success
        this.debug_afficher_erreur_reelle(reponse)
        on_success(reponse)
      },
      (error: any) => {// on error
        this.on_taf_get_error(error, path)
      }
    )
  }
  on_taf_get_error(error: any, path: string) {
    // this.infos.network?.status = false;
    // this.infos.network?.message = error
    this.Swal_error("Vérifiez votre connexion")
  }

  async taf_post(path: string, params: any, on_success: (...args: any[]) => void, on_error: (...args: any[]) => void) {
    const api_url = this.debug_url(this.taf_base_url + path);

    let body: any;

    //  si déjà FormData, on l’envoie tel quel
    if (params instanceof FormData) {
      body = params;
    } else {
      // sinon on construit FormData à partir d’un objet
      const formdata = new FormData();
      for (const key in params) {
        if (params[key] === undefined || params[key] === null) continue;
        formdata.append(key, params[key]);
      }
      body = formdata;
    }

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.infos.token.token_key,
      })
    };

    this.http.post(api_url, body, httpOptions).subscribe(
      (reponse: any) => { this.debug_afficher_erreur_reelle(reponse); on_success(reponse); },
      (error: any) => this.on_taf_post_error(error, on_error)
    );
  }

  async taf_post_object(path: string, data_to_send: any, on_success: (...args: any[]) => void, on_error: (...args: any[]) => void, force_online: boolean = true) {
    if (!force_online) {
      let segments = path.split("/")
      let dernier = segments[segments.length - 1]
      if (dernier.includes("get")) {// reception
        let reponse_offline = await this.get_from_local_storage(path + JSON.stringify(data_to_send))
        if (reponse_offline != null) {
          on_success(reponse_offline)
          console.log("On charge les données locales en attendant = ", reponse_offline)
        }
      }
    }

    let api_url = this.debug_url(this.taf_base_url + path);
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.infos.token.token_key,
      })
    };
    this.http.post(api_url, data_to_send, httpOptions).subscribe(
      (reponse: any) => {// on success
        this.debug_afficher_erreur_reelle(reponse)
        on_success(reponse)
        this.save_on_local_storage(path + JSON.stringify(data_to_send), reponse)
      },
      (error: any) => {// on error
        this.on_taf_post_error(error, on_error)
      }
    )
  }

  on_taf_post_error(error: any, on_error: any) {
    // this.infos.network?.status = false;
    // this.infos.network?.message = error
    this.Swal_info("Merci de vérifier votre connexion")
    on_error(error)
  }

  format_date(date: string) {
    let res = moment(date).locale("fr").format('DD-MM-YYYY')
    return res
  }
  format_date2(date: string) {
    let res = moment(date).locale("fr").format('DD-MM-YYYY à HH:mm')
    return res
  }
  format_date3(date: string) {
    let res = moment(date).locale("fr").format('YYYY-MM-DD')
    return res
  }

  // ✅ Groupes (ex. "Recouvrement") : un groupe n'a pas de droit propre, sa
  // visibilité découle uniquement de celle de ses enfants — chaque enfant
  // reste filtré individuellement par son propre can(), sinon on ré-introduit
  // le même bug que sur Paramètres (tout un sous-menu visible dès qu'on a
  // accès au parent, sans vérifier les droits de chaque item).
  custom_menu() {
    this.menu = this.full_menu
      .map((one: any) => {
        if (one.children?.length) {
          return { ...one, children: one.children.filter((child: any) => this.can(child.url)) };
        }
        return one;
      })
      .filter((one: any) => {
        if (one.children) return one.children.length > 0;
        return this.can(one.url)
      })
  }
  custom_redirect_user() {
    this.route.navigate(['/home/profil'])

  }
  Swal_success(title: any, time: number = 1000) {
    let succes = Swal.fire({
      title: title,
      icon: "success",
      timer: time
    });
    return succes
  }

  Swal_error(title: any, time: number = 10000) {
    let error = Swal.fire({
      title: title,
      icon: "error",
      // timer: time
    });
    return error
  }
  Swal_info(title: any) {
    let info = Swal.fire({
      title: title,
      icon: "info"
    });
    return info
  }
  async Swal_confirm(titre: any, text: any) {
    const result = await Swal.fire({
      title: titre,
      text: text,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non"
    });
    return result.isConfirmed;
  }

  transformer_les_publicites(data: any[], ignore_filtre: boolean = true) {
    return data.
      filter((actu: any) => ignore_filtre || actu.status_contribuable == 1).
      
      map((actu: any) => {
        let un_paiement_publicite = Object.assign(actu, {})

        un_paiement_publicite.date_expiration = moment(un_paiement_publicite.date_publicite).add(un_paiement_publicite.nombre_paiement * this.getBadgeDelai(un_paiement_publicite.duree_unitaire).jours, 'day').format("DD-MM-YYYY HH:mm");
        un_paiement_publicite.etat_renouvellement = moment(un_paiement_publicite.date_expiration).locale('fr').endOf('day').fromNow()
        un_paiement_publicite.expire = moment().isAfter(moment(un_paiement_publicite.date_expiration))

        // === AJOUT: sécuriser date_expiration / etat_renouvellement / expire ===
        {
          const _exp = moment(un_paiement_publicite.date_expiration, "DD-MM-YYYY HH:mm", true);
          if (!_exp.isValid()) {
            un_paiement_publicite.date_expiration = null;
            un_paiement_publicite.etat_renouvellement = "date invalide";
            un_paiement_publicite.expire = false;
          } else {
            // recalcul propre (au cas où .fromNow() précédent a eu un souci de locale/format)
            un_paiement_publicite.etat_renouvellement = _exp.locale('fr').endOf('day').fromNow();
            un_paiement_publicite.expire = moment().isAfter(_exp);
          }
        }
        // on mémorise la valeur relative calculée, au cas où le badge serait vide
        const _etat_relatif_calcule = un_paiement_publicite.etat_renouvellement;
        // === FIN AJOUT ===

        un_paiement_publicite.agent = un_paiement_publicite.id_agent ? ("A°" + un_paiement_publicite.id_agent + "-" + un_paiement_publicite.prenom_a + " " + un_paiement_publicite.nom_a) : ""
        // un_paiement_publicite.tarif = un_paiement_publicite.nombre_paiement + " x " + un_paiement_publicite.nom_taxe + "-" + un_paiement_publicite.titre + " (" + un_paiement_publicite.quantite + " " + this.getBadgeUnite(un_paiement_publicite.unite_unitaire).text + " - " + un_paiement_publicite.prix_unitaire + "Fcfa" + " - " + this.getBadgeDelai(un_paiement_publicite.duree_unitaire).text + ")"
        un_paiement_publicite.tarif = un_paiement_publicite.nom_taxe + "-" + un_paiement_publicite.titre + " (" + (un_paiement_publicite.type_tarif == 2 ? "variable" : (un_paiement_publicite.quantite + " " + this.getBadgeUnite(un_paiement_publicite.unite_unitaire).text + " - " + un_paiement_publicite.prix_unitaire + "Fcfa")) + " - " + this.getBadgeDelai(un_paiement_publicite.duree_unitaire).text + ")"
        un_paiement_publicite.date = moment(un_paiement_publicite.created_at).format("DD-MM-YYYY HH:mm")
        un_paiement_publicite.date_paiement_formated = moment(un_paiement_publicite.date_paiement).format("DD-MM-YYYY")
        un_paiement_publicite.date_publicite_formated = moment(un_paiement_publicite.date_publicite).format("DD-MM-YYYY")

        // === AJOUT: éviter "Invalid date" sur les autres formats ===
        if (!moment(un_paiement_publicite.created_at).isValid()) {
          un_paiement_publicite.date = null;
        }
        if (!moment(un_paiement_publicite.date_paiement).isValid()) {
          un_paiement_publicite.date_paiement_formated = null;
        }
        if (!moment(un_paiement_publicite.date_publicite).isValid()) {
          un_paiement_publicite.date_publicite_formated = null;
        }
        // === FIN AJOUT ===

        un_paiement_publicite.etat_renouvellement = this.getBadge(un_paiement_publicite).text
        un_paiement_publicite.couleur_etat_renouvellement = this.getBadge(un_paiement_publicite).color

        // === AJOUT: fallback si le badge ne renvoie rien d'exploitable ===
        if (!un_paiement_publicite.etat_renouvellement) {
          un_paiement_publicite.etat_renouvellement = _etat_relatif_calcule || "date invalide";
        }
        if (!un_paiement_publicite.couleur_etat_renouvellement) {
          un_paiement_publicite.couleur_etat_renouvellement = undefined;
        }
        // === FIN AJOUT ===

        un_paiement_publicite.est_renouvele = data.find((one: any) => one.id_paiement_publicite_parent == un_paiement_publicite.id_paiement_publicite) ? true : false
        if (un_paiement_publicite.est_renouvele) {
          un_paiement_publicite.etat_renouvellement = "renouvelé"
          un_paiement_publicite.couleur_etat_renouvellement = "success"
        }

        un_paiement_publicite.montant = (un_paiement_publicite.type_tarif == 2 ? (un_paiement_publicite.montant_tarif_variable * un_paiement_publicite.nombre_paiement) : (un_paiement_publicite.montant_total))
        return un_paiement_publicite
      })
  }

  transformer_les_contribuables(data: any[]) {
    return data.map((un_contribuable: any) => {
      un_contribuable.les_taxes = un_contribuable?.les_taxes || []
      un_contribuable.les_activites_taxes = un_contribuable.les_taxes.reduce((res: any, one_taxe: any) => {
        let activite = (un_contribuable.les_activites || []).find((one_activite: any) => one_activite.id_activite == one_taxe.id_activite)
        if (activite) {
          let activite_existe_index = res.findIndex((one_activite: any) => one_activite.id_activite == one_taxe.id_activite)
          if (activite_existe_index != -1) {
            res[activite_existe_index].les_taxes.push(one_taxe)
          } else {
            activite.les_taxes = [one_taxe]
            res.push(activite)
          }
        } else {
          let activite_existe_index = res.findIndex((one_activite: any) => one_activite.id_activite == 0)
          if (activite_existe_index != -1) {
            res[activite_existe_index].les_taxes.push(one_taxe)
          } else {
            res.push({ id_activite: 0, titre: "Autres", les_taxes: [one_taxe] })
          }
        }
        return res
      }, [])
      un_contribuable.text_taxes = un_contribuable.les_taxes.map((une_taxe: any) => une_taxe.nom).join(', ')
      let nombre_taxe = un_contribuable.les_taxes.length
      un_contribuable.text_taxes = nombre_taxe > 0 ? (nombre_taxe + " - " + un_contribuable.text_taxes) : ""

      let etat = this.getBadgeC(un_contribuable.status)
      un_contribuable.status_text = etat.text
      un_contribuable.status_color = etat.color

      un_contribuable.les_paiements = this.transformer_les_publicites(un_contribuable.les_paiements || [])
      un_contribuable.montant = un_contribuable.les_paiements.reduce((res: number, actu: any) => {
        res += +actu.montant
        return res
      }, 0)
      un_contribuable.tarif = un_contribuable.les_paiements.map((actu: any) => {
        return actu.tarif
      }, 0).join(", ")
      return un_contribuable
    })
  }

  getBadgeC(status: number) {
    switch (status) {
      case 1:
        return { color: 'success', text: 'Actif' };
      case 2:
        return { color: 'secondary', text: 'Autre' };
      case 0:
        return { color: 'danger', text: 'inactif' };
      default:
        return { color: 'secondary', text: 'Autre' };
    }
  }
  getBadgeDelai(status: string) {
    switch (status) {
      case "1":
        return { text: "Hebdomadaire", jours: 7 };
      case "2":
        return { text: "Mensuel", jours: 30 }
      case "3":
        return { text: "Annuel", jours: 365 }
      case "4":
        return { text: "Non renouvelable", jours: 0 }
      case "5":
        return { text: "Journalier", jours: 1 }
      default:
        return { text: "--", jours: 0 }
    }
  }

  getBadgeUnite(status: string) {
    switch (status) {
      case "1":
        return { color: 'secondary', text: 'm²' };
      case "2":
        return { color: 'secondary', text: 'En tout' };
      default:
        return { color: 'secondary', text: '--' };
    }
  }
  getBadge(item: any) {
    if (item.expire) {
      return { color: 'danger', text: item.etat_renouvellement };
    } else {
      return { color: 'success', text: item.etat_renouvellement };
    }
  }

  can(id: string) {
    // if (this.infos.current_mairie?.id_privilege == 7) {// super admin
    //   return true
    // }
    let menu_oglet_access = this.infos.les_droits_agent.filter((du: Action) => du.id == id)// || du.id.includes(id) || id.includes(du.id))// && du.menu == menu && du.ongle == ongle)
    return menu_oglet_access.length > 0
  }
  get_current_mairie(new_infos: any): any {
    // Si l'agent est un collecteur avec une mairie active → la priorité
    if (new_infos.mairie_active_collecteur) {
      // On cherche la mairie complète dans les_mairies pour avoir tous les droits
      const mairie_active = (new_infos.les_mairies || []).find(
        (m: any) => m.id_mairie == new_infos.mairie_active_collecteur.id_mairie
      );
      // Si trouvée dans les_mairies (avec les_droits etc.) → on la retourne
      // Sinon on retourne l'objet brut de collecteur_mairie
      return mairie_active || new_infos.mairie_active_collecteur;
    }

    // Sinon : agent normal → première mairie de la liste (comportement actuel)
    return (new_infos.les_mairies || [])[0] || {};
  }
  async update_infos(new_infos?: any) {
    this.preference = (await this.get_from_local_storage("preference")) || this.preference

    if (!new_infos) {
      // ── Rafraîchissement (rechargement de page) ───────────────────────────
      this.infos = await this.get_from_local_storage("infos")
      console.log("update_infos rafraichissement= ", this.infos);

    } else if (!new_infos.token_key) {
      // ── MAJ infos agent (appelé par get_privilege) ────────────────────────
      this.infos.agent = new_infos.agent
      this.infos.les_mairies = new_infos.les_mairies

      // Préserver la mairie choisie manuellement (cas percepteur qui sélectionne une mairie)
      // au lieu de retomber sur la première mairie de la liste (ex: Pikine).
      const selected_id_mairie = this.infos?.mairie_manually_selected
        ? this.infos?.current_mairie?.id_mairie
        : null;
      const selected_mairie = selected_id_mairie
        ? (new_infos.les_mairies || []).find((m: any) => String(m.id_mairie) === String(selected_id_mairie))
        : null;

      // fallback standard si aucune mairie manuelle valide
      this.infos.current_mairie = selected_mairie || this.get_current_mairie(new_infos);
      if (!selected_mairie && this.infos?.mairie_manually_selected) {
        this.infos.mairie_manually_selected = false;
      }

      this.infos.les_droits_agent = this.get_les_doits()
      console.log("update_infos MAJ= ", this.infos);

    } else {
      // ── Nouvelle connexion ────────────────────────────────────────────────
      this.infos = new_infos
      const helper = new JwtHelperService();
      const token_key = this.infos.token_key
      const decodedToken = helper.decodeToken(token_key);
      const expirationDate = helper.getTokenExpirationDate(token_key);
      const isExpired = helper.isTokenExpired(token_key);
      this.infos.token = {
        token_key,
        token_decoded: decodedToken,
        user_connected: decodedToken.taf_data,
        is_expired: isExpired,
        date_expiration: expirationDate
      }
      //  mairie_active_collecteur vient maintenant d'auth_2 aussi
      this.infos.current_mairie = this.get_current_mairie(new_infos);
      this.infos.les_droits_agent = this.get_les_doits()
      console.log("update_new_infos login/inscription= ", this.infos);
    }

    if (this.infos.token.is_expired) {
      this.Swal_error("Votre session s'est expiré! Veuillez vous connecter à nouveau", 3000)
      return
    }
    if (!this.infos.les_droits_agent) {
      this.Swal_error("Vous n'êtes pas autorisé à accéder à ce contenu", 3000)
      return
    }
    await this.save_on_local_storage("infos", this.infos)
    this.custom_menu()
  }
  get_les_doits() {
    let les_droit_role_agent = JSON.parse(this.infos.current_mairie?.les_droits || "[]")
    let les_droit_agent = JSON.parse(this.infos.agent.les_droits_agent || "[]")
    let les_droits_mairie = JSON.parse(this.infos.current_mairie?.les_droits_mairie || "[]")
    let les_droits = []
    if (les_droits_mairie.length > 0 && les_droit_agent.length > 0) {// si les droits de l'mairie sont définis et les droits de l'agent le sont aussi
      console.log("si les droits de l'mairie sont définis et les droits de l'agent le sont aussi");

      les_droits = les_droits_mairie.filter((droitmairie: any) =>
        les_droit_agent.some((droitagent: any) => droitagent.id === droitmairie.id)
      );

    } else if (les_droits_mairie.length > 0 && les_droit_role_agent.length > 0) {// si les droits de l'mairie sont définis
      console.log("si les droits de l'mairie sont définis");

      les_droits = les_droits_mairie.filter((droitmairie: any) =>
        les_droit_role_agent.some((droitagent: any) => droitagent.id === droitmairie.id)
      );

    } else if (les_droit_agent.length > 0) {// si les droits de l'agent sont définis alors que les droits de l'mairie ne le sont pas
      console.log("si les droits de l'agent sont définis alors que les droits de l'mairie ne le sont pas");

      les_droits = les_droit_agent
    } else { // si les droits de l'agent ne sont pas définis ni les droits de l'mairie le sont
      console.log("si les droits de l'agent ne sont pas définis ni les droits de l'mairie le sont");

      les_droits = les_droit_role_agent
    }
    console.log("les_droits= ", les_droits);

    return les_droits
  }

  deconnexion() {
    this.delete_from_local_storage("infos")
    this.infos.network = {
      token: undefined,
      status: true,
      message: "Aucun probléme détecté",
    }
    this.infos.token = {
      token_key: null,
      token_decoded: null,
      user_connected: null,
      is_expired: null,
      date_expiration: null
    }
    this.route.navigate(['/'])
  }

  get_privilege(call_back: (...args: any[]) => void) {
    let params = {
      id_agent: this.infos.agent.id_agent
    }
    this.loading_les_droits = true;
    this.taf_post_object('agent/get2', params, async (reponse: any) => {
      if (reponse.status) {
        await this.update_infos(reponse.data)
        call_back();
        setTimeout(() => {
          this.loading_les_droits = false;
        }, 500);
      } else {
        console.log("L'opération sur la table membre a échoué. Réponse= ", reponse);
        this.Swal_error("L'opération a echoué");
        this.loading_les_droits = false;
      }
    },
      (error: any) => {
        this.loading_les_droits = false;
      }, true);
  }
  jant_group_by(tableau: any[], colonnes: { colonne: string, keys: string[] }[]): any[] {
    if (colonnes.length === 0) {
      return tableau;
    }
    return map(
      _.groupBy(tableau, (item: any) => item[colonnes[0].colonne]),
      (arr: Array<any>, key: string) => ({
        ..._.pick(arr?.[0], colonnes[0].keys),
        items: this.jant_group_by(arr, colonnes.slice(1))
      })
    );
  }
  
  decode_token(token_text: string) {
    const helper = new JwtHelperService();
    const decodedToken = helper.decodeToken(token_text);
    const expirationDate = helper.getTokenExpirationDate(token_text);
    const isExpired = helper.isTokenExpired(token_text);

    return {
      token_key: token_text,
      token_decoded: decodedToken,
      user_connected: decodedToken.taf_data,
      is_expired: isExpired,
      date_expiration: expirationDate
    }
  }

  update_preference(key: string, value: any) {
    this.preference[key] = value
    this.save_on_local_storage("preference", this.preference)
  }

  getDocumentUrl(path: any): string {
    if (!path) return "";

    // si on reçoit un objet/array (cas backend), on tente de récupérer le nom
    if (typeof path === "object") {
      path = path?.name || path?.filename || "";
    }

    const filename = String(path).split("/").pop(); // garde juste le nom
    const base = (this.taf_base_url || "").replace(/\/+$/, "/");

    return base + "deliberation/uploads.old/deliberations/" + encodeURIComponent(filename || "");
  }

}
